module.exports = __webpack_public_path__ + "img/1538073716.e21f74aa.jpg";